<div class="user-dropdown large-width"
     id="userDropdownMenuParent"
     [class.show]="isDropdownActive"
     yp-e2e-id="userDropdownMenuParent">
  <div class="user-dropdown-toggle"
       id="userDropdownMenu"
       yp-e2e-id="userDropdownMenu"
       data-bs-toggle="dropdown"
       aria-haspopup="true"
       aria-expanded="true">
    <i *ngIf="!userAvatar" class="far fa-user-circle" yp-e2e-id="userAvatarIcon"></i>
    <img yp-e2e-id="userAvatar" class="avatar" *ngIf="userAvatar" [src]="userAvatar"/>
    <i class="fal fa-times"></i>
    <span yp-e2e-id="userName">{{ name }}</span>
  </div>
  <div class="dropdown-menu dropdown-menu--without-styling user-dropdown-menu" aria-labelledby="userDropdownMenu">
    <ul class="user-dropdown-menu-list">
      <li><a
        href="/yopaplus/profile/information"
        title="Edit profile"
        yp-e2e-id="editProfile">
        Edit profile
      </a></li>
      <li *ngIf="canImpersonate">
        <a routerLink="impersonate"
           yp-e2e-id="impersonate-with-another-user">Impersonate another user</a></li>
      <li><a
        href="{{suggestImprovementLink}}"
        title="Suggest improvements"
        target="_blank"
        yp-e2e-id="suggestImprovements">
        Suggest improvements
      </a></li>
      <li><a
        href="{{reportAnIssueLink}}"
        title="Report an issue"
        target="_blank"
        yp-e2e-id="reportAnIssue">
        Report an issue
      </a></li>
      <li><a
        href="{{feedbackLink}}"
        title="360 Feedback"
        target="_blank"
        yp-e2e-id="360Feedback">
        360 Feedback
      </a></li>
      <li><a
        href="{{flexiNSNFLink}}"
        title="Flexi NSNF"
        target="_blank"
        yp-e2e-id="FlexiNSNF">
        Flexi NSNF
      </a></li>
      @if (canRequestSalesProgressionSupport) {
        <li>
          <a href="{{requestSalesProgressionSupportLink}}" title="Request Sales Progression Support" target="_blank"
             yp-e2e-id="request-sales-progression-support">
            Request Sales Progression Support
          </a>
        </li>
      }
      <li><a
        href="{{boardsLink}}"
        title="Boards"
        target="_blank"
        yp-e2e-id="boards">
        Boards
      </a></li>
      <li><a
        href="{{foreignTravelLink}}"
        title="Foreign Travel"
        target="_blank"
        yp-e2e-id="foreignTravel">
        Foreign Travel (Microsoft)
      </a></li>
      <li>
        <a routerLink="foreign-travel" yp-e2e-id="foreign-travel-yh">Foreign Travel (YopaHub)</a>
      </li>
      <li><a title="Log out" routerLink="/logout">Log out</a></li>
    </ul>
  </div>
</div>
